/* ==========================================================
   VITRINA — humo volumétrico + haces de luz para el hero
   Canvas 2D, sin librerías. El humo se dibuja dos veces:
   tenue en toda la escena y brillante (cálido) dentro de cada
   haz de luz, lo que da el efecto de foco atravesando humo.
   ========================================================== */
(function () {
  'use strict';
  var VT = window.VT = window.VT || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function puff(size, rgb, seed) {
    var c = document.createElement('canvas'); c.width = c.height = size;
    var g = c.getContext('2d');
    var rnd = mulberry(seed);
    for (var i = 0; i < 34; i++) {
      var r = size * (0.1 + rnd() * 0.24), a = rnd() * Math.PI * 2, d = rnd() * size * 0.24;
      var x = size / 2 + Math.cos(a) * d, y = size / 2 + Math.sin(a) * d;
      var gr = g.createRadialGradient(x, y, 0, x, y, r);
      gr.addColorStop(0, 'rgba(' + rgb + ',' + (0.07 + rnd() * 0.1) + ')');
      gr.addColorStop(1, 'rgba(' + rgb + ',0)');
      g.fillStyle = gr; g.beginPath(); g.arc(x, y, r, 0, 7); g.fill();
    }
    g.globalCompositeOperation = 'destination-in';
    var m = g.createRadialGradient(size / 2, size / 2, size * .08, size / 2, size / 2, size / 2);
    m.addColorStop(0, 'rgba(0,0,0,1)'); m.addColorStop(1, 'rgba(0,0,0,0)');
    g.fillStyle = m; g.fillRect(0, 0, size, size);
    return c;
  }
  function mulberry(a) { return function () { a |= 0; a = a + 0x6D2B79F5 | 0; var t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }

  function Smoke(hero) {
    this.hero = hero;
    this.cv = hero.querySelector('[data-smoke]');
    if (!this.cv) return;
    this.ctx = this.cv.getContext('2d');
    this.targets = Array.prototype.slice.call(hero.querySelectorAll('[data-light-target]'));
    var warm = hero.getAttribute('data-light') || '255,200,130';
    var amt = parseFloat(hero.getAttribute('data-smoke-amount') || '1');
    this.texGrey = [puff(256, '190,192,204', 7), puff(256, '170,172,186', 19)];
    this.texWarm = [puff(256, warm, 7), puff(256, warm, 19)];
    this.warm = warm;
    this.light = this.targets.map(function () { return { v: 0, target: 0, flick: 0 }; });
    this.px = 0; this.py = 0; this.sx = 0;
    this.amount = amt;
    this.t = 0;
    this.resize();
    var n = Math.round((this.W < 700 ? 26 : 52) * amt);
    this.ps = [];
    for (var i = 0; i < n; i++) this.ps.push(this.spawn({}, true));
    var self = this;
    window.addEventListener('resize', function () { self.resize(); });
    this.visible = true;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { self.visible = e[0].isIntersecting; if (self.visible) self.loop(); }).observe(hero);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) self.loop(); });
    if (reduce) { this.light.forEach(function (l) { l.v = l.target = 1; }); this.frame(); }
    else this.loop();
  }
  Smoke.prototype.resize = function () {
    var r = this.hero.getBoundingClientRect();
    this.dpr = (this.W > 900 ? 0.5 : 0.6); // el humo es suave: media resolución basta y rinde 4x
    this.W = r.width; this.H = r.height;
    this.cv.width = Math.round(this.W * this.dpr); this.cv.height = Math.round(this.H * this.dpr);
    this.ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
  };
  Smoke.prototype.spawn = function (p, initial) {
    var W = this.W, H = this.H;
    p.s = (0.28 + Math.random() * 0.55) * Math.max(W, H) * 0.5;
    p.x = Math.random() * W;
    p.y = initial ? H * (0.25 + Math.random() * 0.85) : H + p.s * 0.25;
    p.vx = (Math.random() - .5) * 0.22;
    p.vy = -(0.12 + Math.random() * 0.32);
    p.r = Math.random() * 6.28; p.vr = (Math.random() - .5) * 0.0025;
    p.life = initial ? Math.random() * 900 : 0; p.max = 900 + Math.random() * 900;
    p.k = Math.random() < .5 ? 0 : 1;
    p.grow = 1 + Math.random() * 0.0007;
    return p;
  };
  Smoke.prototype.lightOn = function (i) { if (this.light[i]) { this.light[i].target = 1; this.light[i].flick = reduce ? 0 : 1; } };
  Smoke.prototype.pointer = function (x, y) { this.px = x; this.py = y; };
  Smoke.prototype.loop = function () {
    var self = this;
    if (this.running || reduce) return;
    this.running = true;
    var tick = function () {
      if (!self.visible || document.hidden) { self.running = false; return; }
      self.frame(); requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };
  Smoke.prototype.beams = function () {
    var hr = this.hero.getBoundingClientRect(), self = this;
    this.sx += (this.px - this.sx) * 0.04;
    return this.targets.map(function (el, i) {
      var r = el.getBoundingClientRect();
      var cx = r.left - hr.left + r.width / 2;
      var bottom = r.bottom - hr.top + r.height * 0.12;
      var sway = Math.sin(self.t * 0.0006 + i * 2.1) * r.width * 0.06 + self.sx * 60;
      var srcX = cx + sway * 1.6 - (i - 1) * r.width * 0.12;
      var top = -10, w0 = r.width * 0.06, w1 = r.width * 0.72;
      return { i: i, top: top, bottom: bottom, x0: srcX, x1: cx + sway * .4, w0: w0, w1: w1, r: r };
    });
  };
  Smoke.prototype.drawSmoke = function (tex, alpha) {
    var c = this.ctx;
    for (var i = 0; i < this.ps.length; i++) {
      var p = this.ps[i];
      var a = Math.sin(Math.PI * Math.min(1, p.life / p.max)) * alpha;
      if (a <= 0.003) continue;
      c.globalAlpha = a;
      c.save(); c.translate(p.x, p.y); c.rotate(p.r);
      c.drawImage(tex[p.k], -p.s * 0.85, -p.s * 0.42, p.s * 1.7, p.s * 0.84); // estirado: volutas, no bolas
      c.restore();
    }
    c.globalAlpha = 1;
  };
  // capa de máscara de haces (baja resolución => bordes suaves de luz real)
  Smoke.prototype.ensureLayers = function () {
    var q = 0.25, w = Math.max(2, Math.round(this.W * q)), h = Math.max(2, Math.round(this.H * q));
    if (!this.mask || this.mask.width !== w || this.mask.height !== h) {
      this.mask = document.createElement('canvas'); this.mask.width = w; this.mask.height = h;
      this.mctx = this.mask.getContext('2d');
    }
    this.q = q;
  };
  Smoke.prototype.drawMask = function (beams) {
    var m = this.mctx, q = this.q, self = this;
    m.setTransform(1, 0, 0, 1, 0, 0);
    m.clearRect(0, 0, this.mask.width, this.mask.height);
    m.setTransform(q, 0, 0, q, 0, 0);
    m.globalCompositeOperation = 'lighter';
    var L = 7;
    beams.forEach(function (b) {
      var I = self.light[b.i].v; if (I < 0.01) return;
      for (var k = 0; k < L; k++) {
        var f = 1 - k / L * 0.78;                // de ancho a angosto: núcleo más brillante
        var g = m.createLinearGradient(0, b.top, 0, b.bottom * 1.05);
        var a = I * (self.W < 700 ? 0.11 : 0.24);
        g.addColorStop(0, 'rgba(255,255,255,' + a + ')');
        g.addColorStop(0.6, 'rgba(255,255,255,' + a * 0.55 + ')');
        g.addColorStop(1, 'rgba(255,255,255,0)');
        m.fillStyle = g;
        m.beginPath();
        m.moveTo(b.x0 - b.w0 * f, b.top); m.lineTo(b.x0 + b.w0 * f, b.top);
        m.lineTo(b.x1 + b.w1 * f, b.bottom * 1.05); m.lineTo(b.x1 - b.w1 * f, b.bottom * 1.05);
        m.closePath(); m.fill();
      }
    });
  };
  Smoke.prototype.frame = function () {
    var c = this.ctx, W = this.W, H = this.H, self = this;
    var now = performance.now(), dt = Math.min(64, this.last ? now - this.last : 16); this.last = now;
    var k = dt / 16;
    this.t += dt;
    for (var i = 0; i < this.ps.length; i++) {
      var p = this.ps[i];
      p.x += (p.vx + Math.sin((p.y + this.t * .02) * 0.004) * 0.18) * k; p.y += p.vy * k; p.r += p.vr * k; p.s *= 1 + (p.grow - 1) * k; p.life += k;
      if (p.life > p.max || p.y < -p.s * .6) this.spawn(p, false);
    }
    var ease = 1 - Math.exp(-dt / 260);
    this.light.forEach(function (l) {
      l.v += (l.target - l.v) * ease;
      if (l.flick > 0) { l.flick -= dt / 900; if (Math.random() < 0.3) l.v *= 0.35; }
    });
    this.ensureLayers();
    var beams = this.beams();
    this.drawMask(beams);

    // 1) capa iluminada: luz base + humo cálido, recortada por la máscara suave
    c.setTransform(1, 0, 0, 1, 0, 0);
    c.globalCompositeOperation = 'source-over';
    c.clearRect(0, 0, this.cv.width, this.cv.height);
    c.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
    c.fillStyle = 'rgba(' + this.warm + ',0.62)'; c.fillRect(0, 0, W, H);
    c.globalCompositeOperation = 'lighter';
    this.drawSmoke(this.texWarm, 2.2 * Math.min(1.4, this.amount));
    c.globalCompositeOperation = 'destination-in';
    c.setTransform(1, 0, 0, 1, 0, 0);
    c.imageSmoothingEnabled = true; c.imageSmoothingQuality = 'high';
    c.drawImage(this.mask, 0, 0, this.cv.width, this.cv.height);
    c.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);

    // 2) humo tenue general (aditivo)
    c.globalCompositeOperation = 'lighter';
    this.drawSmoke(this.texGrey, 0.26 * Math.min(1.3, this.amount));

    // 3) destello de cada lámpara
    beams.forEach(function (b) {
      var I = self.light[b.i].v; if (I < 0.01) return;
      var R = b.w0 * 6;
      var fl = c.createRadialGradient(b.x0, 0, 0, b.x0, 0, R);
      fl.addColorStop(0, 'rgba(255,244,225,' + (0.85 * I) + ')'); fl.addColorStop(.4, 'rgba(255,225,180,' + (0.25 * I) + ')'); fl.addColorStop(1, 'rgba(255,220,170,0)');
      c.fillStyle = fl; c.fillRect(b.x0 - R, 0, R * 2, R);
    });
    c.globalCompositeOperation = 'source-over';
  };

  function init() {
    var hero = document.querySelector('[data-hero]');
    if (!hero || hero._smoke) return;
    hero._smoke = VT.smoke = new Smoke(hero);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { var h = document.querySelector('[data-hero]'); if (h) { h._smoke = null; init(); } });
})();
